import './workerShim';

let channel;

self.onmessage = function (e) {
  const { type, data } = e.data;

  if (type === 'INIT_CHANNEL') {
    channel = new BroadcastChannel('yabble-broadcast-channel');

    channel.onmessage = function (event) {
      self.postMessage({
        type: 'BROADCAST_RECEIVED',
        data: event.data,
      });
    };

    self.postMessage({ type: 'CHANNEL_READY' });
  }

  if (type === 'SEND_MESSAGE' && channel) {
    channel.postMessage(data);
  }

  if (type === 'CLOSE_CHANNEL' && channel) {
    channel.close();
    channel = null;
  }
};
